import type { RouteItem } from './types';
import type { Relation } from '../utils';
import { toTree } from '../utils';
import LazyWrapper from '@/components/lazy-wrapper';

export function genRoutes(relation: Relation<RouteItem>) {
  return toTree(relation, ({ element, menu, auth, handle, ...item }) => {
    const element_ = <LazyWrapper>{element}</LazyWrapper>;
    return {
      element: auth ? <AccessPage authKey={auth.key}>{element_}</AccessPage> : element_,
      ...item,
    };
  });
}
